import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, Input, Spin, Button, message } from 'antd'
import NotificationAPI from '@/API/notification'
import { withTranslation } from 'react-i18next';
import styled from "styled-components"
import feeSvg from '../assets/image/fee.svg'
// import lockSvg from '../assets/image/lock-notification.svg'
import unlinkSvg from '../assets/image/unlink-notification.svg'
import reStartPng from '../assets/image/restart.png'
import lockScreenPng from '../assets/image/lock-screen.png'
const { TextArea } = Input

const TemplateRow =styled.div`
  background-color:#f4f5f9;
`

const CardContainer =styled.div`
  display:inline-block;
  margin:0 24px 24px 0;
  vertical-align:top;
`

const TemplateCard =styled(Card)`
  width:348px;
  border-radius:4px !important;
  .ant-card-body{
    padding:0;
  }
`

const CardHeader =styled.div`
  display:flex;
  align-items:center;
  padding:24px;
  border-bottom:1px solid #F4F6F9;
`

const CardBody =styled.div`
  padding:24px;
`

const TemplateTextArea=styled(TextArea)`
  margin-top: 10px;
  &.ant-input{
    height:160px;
  }
`

const HeaderImg =styled.img`
  width:60px;
  height:60px;
  margin-right:16px;
`

const HeaderTilte =styled.span`
  font-weight:bold;
`

const ButtonGroup=styled.div`
  margin-top:24px;
  text-align:right;
  a{
    margin-left:16px;
  }
`

const count=3

const icons=[feeSvg,unlinkSvg,reStartPng,lockScreenPng, reStartPng]

class Inform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      types:[this.props.t('Payment Reminder'),this.props.t('Unbind Contract'),this.props.t('Enrollment Message'),],  
      tits:Array(count).fill(''),
      titles:Array(count).fill(''),
      templates:Array(count).fill(''),
      tems:Array(count).fill(''),
      editShow:Array(count).fill(false),
      loading:Array(count).fill(false)
    };
  }
  componentDidMount() {
    this.state.templates.forEach((template,index)=>{
      const type = index === 0 ? 0 : index === 1 ? 2 : 5
      this.setState(prevState => ({loading: prevState.loading.map((el, i) => i === index ? true : el)}))
      NotificationAPI.getNotification({type}).then((res)=>{
        if(!res.code){
          if(res.data){
            this.setState(prevState => ({templates: prevState.templates.map((el, i) => i === index ? res.data.notifyContent : el),titles: prevState.titles.map((el, i) => i === index ? res.data.notifyTitle : el)}),()=>{
              this.setState((prevState)=>({tems:prevState.templates,tits:prevState.titles}))
            })
          }
        }
        this.setState(prevState => ({loading: prevState.loading.map((el, i) => i === index ? false : el)}))
      })
    })
  }
  handleCancel(index){
    this.setState(prevState => {
      let tems=prevState.tems.slice()
      let tits=prevState.tits.slice()
      tems[index]=prevState.templates[index]
      tits[index]=prevState.titles[index]
      return {
        editShow: prevState.editShow.map((el, i) => i === index ? false : el),
        tems: tems,
        tits: tits
      }
    })
  }
  //编辑模板，提交按钮
  handleClick(index){    
    if(!this.state.editShow[index]){
      this.setState(prevState => ({editShow: prevState.editShow.map((el, i) => i === index ? true : el)}))
    }else{     
      if(this.state.tits[index].length>78){
        message.warning('No more than 78 characters')
        return
      }
      const type = index === 0 ? 0 : index === 1 ? 2 : 5
      this.setState(prevState => ({loading: prevState.loading.map((el, i) => i === index ? true : el)}))
      NotificationAPI.setNotification({type,notifyContent:this.state.tems[index],notifyTitle:this.state.tits[index]}).then((res)=>{
        if(!res.code){
          this.setState(prevState=>{           
            let editShow=prevState.editShow.slice()          
            let templates=prevState.templates.slice()
            let titles=prevState.titles.slice()
            editShow[index]=false
            templates[index]=prevState.tems[index]
            titles[index]=prevState.tits[index]
            return {
              editShow,
              templates,
              titles
            }
          })
        }
        this.setState(prevState => ({loading: prevState.loading.map((el, i) => i === index ? false : el)}))
      })
    }
  }
  handleTitleChange(e,index){
    let value=e.target.value
    this.setState(prevState => ({tits: prevState.tits.map((el, i) => i === index ? value : el)}))
  }
  handleTemplateChange(e,index){
    let value=e.target.value
    this.setState(prevState => ({tems: prevState.tems.map((el, i) => i === index ? value : el)}))
  }
  render() {
    const {editShow}=this.state
    const { t } = this.props;    
    let sendTemplateCard = (
        this.state.types.map((title,index)=>(
          <CardContainer key={title}>
            <Spin spinning={this.state.loading[index]}>
              <TemplateCard bordered={false}>
                <CardHeader>
                  <HeaderImg src={icons[index]}></HeaderImg>
                  <HeaderTilte>{title}</HeaderTilte>
                </CardHeader>
                <CardBody>
                  <Input disabled={!editShow[index]} value={this.state.tits[index]} onChange={(e)=>{this.handleTitleChange(e,index)}}></Input>
                  <TemplateTextArea disabled={!editShow[index]} value={this.state.tems[index]} onChange={(e)=>{this.handleTemplateChange(e,index)}}></TemplateTextArea>
                  {
                    this.state.editShow[index]?(
                      <ButtonGroup>
                        <Button onClick={()=>{this.handleCancel(index)}}>{t('Cancel')}</Button>
                        <Button type="primary" onClick={()=>{this.handleClick(index)}}>{t('Save')}</Button>
                      </ButtonGroup>
                    ):(
                      <ButtonGroup>
                        <Button type="primary" onClick={()=>{this.handleClick(index)}}>{t('Edit')}</Button>
                      </ButtonGroup>
                    )
                  }
                </CardBody>
              </TemplateCard>
            </Spin>
          </CardContainer>
        ))
      )
    
    if(this.props.curOperator === 'MYDG'){      
      sendTemplateCard = (
        this.state.types.map((title,index)=>(
          <CardContainer key={title} style={(index === 0 || index === 1 || index === 2) ? {display:'none'} : null}>
            <Spin spinning={this.state.loading[index]}>
              <TemplateCard bordered={false}>
                <CardHeader>
                  <HeaderImg src={icons[index]}></HeaderImg>
                  <HeaderTilte>{title}</HeaderTilte>
                </CardHeader>
                <CardBody>
                  <Input disabled={!editShow[index]} value={this.state.tits[index]} onChange={(e)=>{this.handleTitleChange(e,index)}}></Input>
                  <TemplateTextArea disabled={!editShow[index]} value={this.state.tems[index]} onChange={(e)=>{this.handleTemplateChange(e,index)}}></TemplateTextArea>
                  {
                    this.state.editShow[index]?(
                      <ButtonGroup>
                        <Button onClick={()=>{this.handleCancel(index)}}>{t('Cancel')}</Button>
                        <Button type="primary" onClick={()=>{this.handleClick(index)}}>{t('Save')}</Button>
                      </ButtonGroup>
                    ):(
                      <ButtonGroup>
                        <Button type="primary" onClick={()=>{this.handleClick(index)}}>{t('Edit')}</Button>
                      </ButtonGroup>
                    )
                  }
                </CardBody>
              </TemplateCard>
            </Spin>
          </CardContainer>
        ))
      )
    }
    return (
      <TemplateRow gutter={24}>
        {sendTemplateCard}
      </TemplateRow>
    )
  }
}
const mapStateToProps = (state)=>{
  return {
    roleId:state.roleId,
    curOperator:state.operator
  }
}

export default connect(mapStateToProps)(withTranslation()(Inform))